/* eslint-disable max-len */
import React, {
  createContext, useContext, useEffect, useMemo, useState,
} from 'react';
import token from 'entities/token';
import { UserPool } from './config';

async function getRefreshedSession(cognitoUser) {
  return new Promise((resolve, reject) => {
    cognitoUser.getSession((error, session) => {
      if (error) reject(error);
      if (!session) reject(new Error('Could not obtain session'));

      if (session.isValid()) {
        resolve(session);
      } else {
        cognitoUser
          .refreshSession(token.getRefreshToken(), (refreshError, newSession) => {
            if (refreshError) reject(refreshError);
            if (!newSession) reject(new Error('Could not refresh session'));

            resolve(newSession);
          });
      }
    });
  });
}
const hasToken = Boolean(window.sessionStorage.getItem('accessToken'));
const dataUserDemo = {
  _cognitoUser: {
    Username: {
      accessToken: {
        jwtToken: 'eyJraWQiOiI2aEVqQndxK1NOcWhmVlwvR3BpMzRzc2lZSWgrVjgzSUxBV1NyVk5sZFUrQT0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiI2MzQ0ODRhYy01Y2FiLTRmYzEtYjUzMi1lZjgzNjVkNTFlMGQiLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAudXMtZWFzdC0yLmFtYXpvbmF3cy5jb21cL3VzLWVhc3QtMl9CMXRaVHZBY1ciLCJjbGllbnRfaWQiOiIzaTJvcmN0N3NiMGcxMXZxZHE0ZW5maDdqNSIsIm9yaWdpbl9qdGkiOiI5Y2MyOTY4My1kYjUzLTQ3ZmQtYWJlNy02ZWYwMjQxZDMxYjgiLCJldmVudF9pZCI6IjI4MWI4ZDIxLTdhNjEtNDVmOC1iM2M4LTBjYzc0MjdmYWU4OCIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE2NzY0NzU2MDQsImV4cCI6MTY3NjQ3NTkwNCwiaWF0IjoxNjc2NDc1NjA0LCJqdGkiOiJmZTAyZjE5ZS1jNDdiLTRmY2ItYWQ5Zi1kM2JiZmFiZDk2YjciLCJ1c2VybmFtZSI6InRlc3QifQ.SQcj0H_9vbtQzKl6h55cuueYogeYrSnwg-ZZGVEZLmTSLW4SuBE62Kt9xXlHS9DSFU442YQi3sRZO7m1kcnyPFtbO89ZubHWezDBjDomx-Kes14lgCeFM-GwebKiu1FjAq2qvSr37ZbEESwXlvWVq6dNzMBFhBtP594_lcaIVDHpaJ96XxgA_V9ZGJBDVMdWosWS1sbNpbNklkJhUfNmh7f-VQe9CbB6M63-ICdcHtEQOQQR8rFd7YvEPyenYF1QJelunWflsZy_vQX0PYnZp2TzCCwtft8sXsJKaad8IqQGWFTBYaBtg6FSwtgHFdH2EdrkBMFx8jyA6B_-stnOew',
        payload: {
          sub: '634484ac-5cab-4fc1-b532-ef8365d51e0d',
          iss: 'https://cognito-idp.us-east-2.amazonaws.com/us-east-2_B1tZTvAcW',
          client_id: '3i2orct7sb0g11vqdq4enfh7j5',
          origin_jti: '9cc29683-db53-47fd-abe7-6ef0241d31b8',
          event_id: '281b8d21-7a61-45f8-b3c8-0cc7427fae88',
          token_use: 'access',
          scope: 'aws.cognito.signin.user.admin',
          auth_time: 1676475604,
          exp: 1676475904,
          iat: 1676475604,
          jti: 'fe02f19e-c47b-4fcb-ad9f-d3bbfabd96b7',
          username: 'marcy_temperini',
        },
      },
      refreshToken: {
        token: 'eyJjdHkiOiJKV1QiLCJlbmMiOiJBMjU2R0NNIiwiYWxnIjoiUlNBLU9BRVAifQ.PO9ECSudKXaHlhC6KgNKXPpL4H3o8qGHXr0tjLcsTNox-YEApgPh7ch6MIWFX_eGDn1T7Q1MFq3PoXYTwPaFMMRYn8Om_8wL8vrcfiHgrqTkhurR1-PfuOVykaHHJsCx3pPC7dVPpIMX4fbkADKqaozdJIr2jjglHg5dBz0eZlZORz-zfsNBnNsxiOoukhcCCZDU7XEJDKgN8utBSvv4vWlv8yF2JS-JQq0dQmf_emkCCCzCLupV2UnmMtm1iOQfrvll5DJE_ZRH6f26Q2Kx-ZXGh6jrU8mkKsvC8Sg6IzvlNtDCuYWeyeMxsJF1cf0Xv7a3YS4EAXeShUcvbhBsgA.rT4rraUZUmfq309h.w7zFNz7h7MSUiYmiy0vkh1EohvUQaOL2oLJAhggd_S9RkFUPhA-vbLpwQOZcBrcgaM3Duea4QwIg5f-i3pKShJ1r5Tw-fwhVkELFmt6trMIsDdq0RQ3kfuV-V1aOenVJJ1Fn_S8z2PEuGq1t4DZJfcnt8JeH8VPY7k4ApYQKJaclqRjW1zzvOBqtiS2MB2_wXKO73WNf4JV_2MmLSjhm3nt9TF5Lf_NmVqG9mQZscBlcFb2V07q0wsAbbACv3LjbeiVyblgR0GkM9zWw7naboYcho4-Ld0dzQlIfqOTyxPQFfxV5gh2rEk5-1bc-1PankIM9WC5nQg-sf8d9SAoGHpc2bJM4a5tDITINxRbmYU7FmR81eMdc54e7_5mLdmaYjCwRk9mBLYvEHBc5uI0Dk-WEgLLUrE99CzTH0dp5PkhwspFfdMstNVqxeFD-rwu3xFgwQLX02bfL1mu46unaq99bThDHDWbsevdlUBKu2whRH4CvYeIurdODwMx5v85uUMzfWvASHBuN4pF6x_y7L9u8Bl06zZUrtkRcx8UkPyN7NHVIneZSNC1F9sXp4M8her5hV9xlbUjZE9-e8g6WRTPz2pxTiAMh7v2Di2nFkX9ZNMGD3NiqOUwvHCW_eKAYdFBb-ne5J1l3FzhG2QiGmo7r7t1T-GwFz9pE8jNOQzt_l9Gn4NGEjZzIs7xbiXr5Xt0wYXTcAT4pzt32c0vFvjpsmYB4IyVPG77Rhc6A2JbN5m6Igjs_hKbUEZrAnDVppbkKXOo_l3xjXLcB-SBwUbbaqJZkZH_Aw_-dKY0k1F2pUOummx0CygV5RdT3PyIPkSLPdhMmycKBVd5DkC9H6M0qDVKTFXWVxJfFIaCpzksLYSkjMPZkvOY2xwBLLar_l9z3VT8htfNgj8DkZkGSDOSYGE6tcRtCM44E7VgQlAihSINH8iH75PEAluG3aYV2Sb2-c2sWAsiiIvGJ_1tn6z9y_lqUpd0cgoB61Thg55i3-0XGv-2qAYaXIMoyBNYpxeUTlNGo-wbQ-qsPZpeqH8KgJ93Xg8ANdmtyM7SGeW9XX2EkrnS_Ae1F3HGSVeUKhdiH05IZtvuafyNfpcl6CrQnxJoS75uhCgpDjElvalR-lWk2Yan2hTOYRNRi8K6zA_i1K2aDRpIl02WL-CndNZGeRPAQ2SaftKMr66nwhqhtXYKpINvYpGWmuE9VHyMqyNtnEjIOthfTZtYr2HSkiEWHCdI6FuN79zmdq1l8qFpIu7rk4LbEtdj-wC0g-NwZwQ.-HXg70phn4zkHcuy0GeXhQ',
      },
      idToken: {
        jwtToken: 'eyJraWQiOiI4RXAyMlJ1YXRsWlVqTWh2UTVWMnlaemVpNnlvR2U3MWtjeldkRFpob3pjPSIsImFsZyI6IlJTMjU2In0.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.QPO6m1F-5lJDEWmlMsMuKQyx5G9CPUjSxfBTr3kv5u_-LQsSIbwWmPEnTI0XzdwckFWcMK3VzBTgivjFpQmkvr_lfUvvMLkfvtWOBYg8y6YBUmr87RRa_4KIKN812IU7uqmYlQ1BsyUHUo5UxCqjIGizDgWuAgqI7mVE3PqZIjVxY9XwkFE36kTqcxV6W48XCqKHm189EemkWFLAnUUQTj6cdIDvoMKSekusDteAEcA3SuLRInpKNigCnBUeZLZBLQ0q2XtaeoSPKxYn_PjPrvZ0bt7GB-2d_M54eIGpsqCgEsffnSr2I_H1UXGzTx3i3FDe-lbltC_LtUfmHs_o3A',
        payload: {
          sub: '634484ac-5cab-4fc1-b532-ef8365d51e0d',
          email_verified: true,
          iss: 'https://cognito-idp.us-east-2.amazonaws.com/us-east-2_B1tZTvAcW',
          phone_number_verified: true,
          'cognito:username': 'marcy_temperini',
          origin_jti: '9cc29683-db53-47fd-abe7-6ef0241d31b8',
          aud: '3i2orct7sb0g11vqdq4enfh7j5',
          full_name: 'Marcy Temperini Prucho',
          event_id: '281b8d21-7a61-45f8-b3c8-0cc7427fae88',
          token_use: 'id',
          auth_time: 1676475604,
          phone_number: '+5533999640132',
          exp: 1676475904,
          pep_id: '{"rede_carenet/hospital_elizabeth_blackwell":"100","rede_carenet/hospital_sao_marcio":"101"}',
          actions: '{"rede_carenet/hospital_elizabeth_blackwell":["ASSISTMANAGE_C_TEMP_PRESET_MH","ASSISTMANAGE_U_PRESET_MH","ASSISTMANAGE_U_PRESET_PUBLICATION_MH","ASSISTMANAGE_R_PRESET_ALLOCATION_MH","ASSISTMANAGE_U_FREQ_SEND_PEP_MH","ASSISTMANAGE_R_CONFIG_ALARM_MH","ACTN_GRANT_2","ASSISTMANAGE_R_PRESET_MH","ASSISTMANAGE_D_PRESET_MH","ASSISTMANAGE_C_PRESET_MH","ACTN_GRANT_1","ASSISTMANAGE_U_PRESET_ALLOCATION_MH","ASSISTMANAGE_R_FREQ_SEND_PEP_MH","ACTN_GRANT_3"],"rede_carenet/hospital_elizabeth_blackwell":["ASSISTMANAGE_U_PRESET_ALLOCATION_MH","ASSISTMANAGE_C_PRESET_MH","ASSISTMANAGE_U_PRESET_PUBLICATION_MH","ASSISTMANAGE_R_FREQ_SEND_PEP_MH","ASSISTMANAGE_U_FREQ_SEND_PEP_MH","ASSISTMANAGE_R_CONFIG_ALARM_MH","ASSISTMANAGE_R_PRESET_ALLOCATION_MH","ASSISTMANAGE_R_PRESET_MH","ASSISTMANAGE_C_TEMP_PRESET_MH","ACTN_GRANT_3","ASSISTMANAGE_D_PRESET_MH","ASSISTMANAGE_U_PRESET_MH"]}',
          iat: 1676475604,
          jti: '22053621-d433-4b8d-9b53-3b0127fda5ba',
          email: 'marcy.prucho@geranv.com.br',
          group: 'rede_carenet',
        },
      },
    },
    Pool: {
      UserPoolId: 'us-east-2_B1tZTvAcW',
      clientId: '3i2orct7sb0g11vqdq4enfh7j5',
      storage: {},
    },
    isValid: true,
    storage: {},
  },
  logout: async () => {
    window.sessionStorage.clear();
    window.location.replace('/login');
  },
};

const isDemo = process.env.REACT_APP_IS_DEMO;

async function getUser() {
  const cognitoUser = UserPool.getCurrentUser();
  if (!cognitoUser) return undefined;

  const session = await getRefreshedSession(cognitoUser);

  if (session) {
    return {
      logout: async () => {
        cognitoUser.signOut();
        token.removeAll();
      },
      _cognitoUser: cognitoUser,
    };
  }

  return undefined;
}

const UserContext = createContext();

function UserProvider({ children }) {
  const [user, setUser] = useState({});

  const contextUser = useMemo(() => ({
    user,
    refresh: async () => {
      setUser(await getUser());
    },
  }), [user]);

  useEffect(() => {
    if (Object.values(user).length === 0 && isDemo && hasToken) {
      setUser(dataUserDemo);
      return;
    }
    contextUser.refresh();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <UserContext.Provider value={contextUser}>{ children }</UserContext.Provider>;
}

export { UserProvider };

export default function useUser() {
  return useContext(UserContext);
}
